import { useContext } from 'react';

import BonusPeriodsContext from 'contexts/BonusPeriodsContext';
import WorkSpaceContext from 'contexts/WorkSpaceContext';

const LIVE_BONUS_PERIOD_STATUSES: BonusTypes.PeriodStatus[] = [
  'active',
  'in review',
  'pending sign off',
];

/**
 * True when exporting a grid inside a driver bonus workspace for a live (not yet
 * finalized) bonus period, in which case exports warn that payments shouldn't be
 * made until the cycle is signed off. Matches on an explicit allow-list of live
 * statuses rather than `!== 'closed'` so that archived periods (and any future
 * non-live status) are treated as non-live.
 */
const useIsLiveBonusPeriodExport = (): boolean => {
  const { workSpace } = useContext(WorkSpaceContext);
  const { selectedBonusPeriod } = useContext(BonusPeriodsContext);

  return (
    !!workSpace &&
    workSpace.campaignType === 'driverBonus' &&
    !!selectedBonusPeriod &&
    LIVE_BONUS_PERIOD_STATUSES.includes(selectedBonusPeriod.status)
  );
};

export default useIsLiveBonusPeriodExport;
